import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../core/logger.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { User, ErrCode } from '../../shared/models';
import { AppsOauthCompleteOutput, AppsOauthValidateOutput, AppsService } from '../../apps/services/apps.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-oauth-app',
    templateUrl: './oauth-app.component.html'
})
export class OauthAppComponent implements OnInit, OnDestroy {

    // TODO: Once OAuth is used for other things change this to a generic Apps help page.
    private helpLink = 'https://www.sync.com/help/how-to-use-slack-with-sync/';

    private subscription: Subscription;
    private nonce: string;
    private redirect: string;
    private user: User;
    public error: ErrCode;
    public permissions: sync.IAppPermissions;

    private appName: string;
    private validated = false;
    private completed = false;

    constructor(
        private log: LoggerService,
        private store: Store<fromRoot.State>,
        private appsService: AppsService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }


    async ngOnInit() {

        this.permissions = {
            apACCOUNT: 1,
            apREAD: 1,
            apWRITE: 1,
            apSHARE: 0,
            apLINK: 1,
        };

        this.setUser();
        this.setNonce();
        this.setRedirect();

        try {
            const validateResp = await this.OauthValidate(this.nonce);
            this.log.info(validateResp);
            this.appName = validateResp.app.name;
            this.validated = true;
        } catch (ex) {
            this.handleErr(ex);
        }
    }

    private setUser() {
        this.subscription = this.store
        .select(fromRoot.getAuthState)
        .subscribe((data) => {
            if (data && !data.authenticated && data.error) {
                // If a user isn't signed in automatically send them back. They should get here without logging in.
                this.router.navigate(['/oauth'], { queryParams: { nonce: this.nonce, redirect: this.redirect } });
            }
            if (data && data.authenticated) {
                this.user = data.user;
            }
        });
    }

    private setNonce() {
        this.nonce = this.route.snapshot.queryParams['nonce'];
        if (!this.nonce) {
            this.log.error('Nonce is missing from URL');
            this.error = new ErrCode(11101);
        }
    }

    private setRedirect() {
        this.redirect = this.route.snapshot.queryParams['redirect'];
        this.log.warn(`User will be redirected to '${this.redirect}'`);
        if (!this.redirect) {
            this.log.error('Redirect is missing from URL');
            this.error = new ErrCode(11101);
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public async oauthAllow() {
        try {

            const completeresp = await this.OauthComplete(this.nonce);
            // Append token generated and appended to redirect url
            this.redirect = this.redirect + '?token=' + completeresp.token;
            this.completed = true;
            setTimeout(() => {
                this.finish();
            }, 5000);
        } catch (ex) {
            this.handleErr(ex);
        }
    }

    public oauthCancel() {
        this.router.navigate(['/files']);
    }

    public finish() {
        window.location.href = this.redirect;
    }

    private OauthValidate(nonce: string): Promise<AppsOauthValidateOutput> {
        return this.appsService.OauthValidate(nonce, this.redirect);
    }

    private OauthComplete(nonce: string): Promise<AppsOauthCompleteOutput> {
        return this.appsService.OauthComplete(nonce, this.user.email);
    }

    private handleErr(data: any) {
        if (data instanceof ErrCode) {
            this.error = data;
        } else if (data && data.error_code) {
            this.error = ErrCode.fromApiLegacy(data);
        } else {
            this.error = new ErrCode(11100);
        }
        this.log.error(data);
    }

}
